import { collectionDetailParams, collectionParams, normalizeCollectionResponse, normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const collectionQuery = async ({ req, params }) => {
	const formattedParams = { ...collectionDetailParams, context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/collections/${params.collectionId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const collectionsQuery = async ({ req, params, query }) => {
	const formattedParams = { ...collectionParams, ...query, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/collections`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
